<template>
  <div>
    <v-row dense>
      <v-col cols="6" v-for="(campagne, index) in listOfCampagnes" :key="index">
        <campagneCard
          :amountOfUsers="campagne.amountOfUsers"
          :title="campagne.title"
          :urlItem="campagne.url"
          @setSnackbar="setSnackbar($event)"
        />
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="color" app>
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
    
    <script>
import request from "../../request";
export default {
  data() {
    return {
      snackbar: false,
      text: "",
      color: "",
      listOfCampagnes: [
        {
          title: "Nieuwe brillen zijn binnen - LENSIE",
          url: "/api/optiek-jo/send-new-glasses-lensie",
          amountOfUsers: "",
        },
        {
          title: "Nieuwe brillen zijn binnen - ZEISS",
          url: "/api/optiek-jo/send-new-glasses-zeiss",
          amountOfUsers: "",
        },
        {
          title: "Nieuwe collectie zonnebrillen - LENSIE",
          url: "/api/optiek-jo/send-new-collection-sun-glasses-lensie",
          amountOfUsers: "",
        },
        {
          title: "Nieuwe collectie zonnebrillen - ZEISS",
          url: "/api/optiek-jo/send-new-collection-sun-glasses-zeiss",
          amountOfUsers: "",
        },
        {
          title: "Reservebril - LENSIE",
          url: "/api/optiek-jo/send-spare-glasses-lensie",
          amountOfUsers: "",
        },
        {
          title: "Reservebril - ZEISS",
          url: "/api/optiek-jo/send-spare-glasses-zeiss",
          amountOfUsers: "",
        },
      ],
    };
  },
  created() {
    const urls = [
      "/api/optiek-jo/new-glasses-lensie-count",
      "/api/optiek-jo/new-glasses-zeiss-count",
      "/api/optiek-jo/new-collection-sun-glasses-lensie-count",
      "/api/optiek-jo/new-collection-sun-glasses-zeiss-count",
      "/api/optiek-jo/spare-glasses-lensie-count",
      "/api/optiek-jo/spare-glasses-zeiss-count",
    ];
    request.getAll(urls, null, (res) => {
      if (res[0]) {
        this.listOfCampagnes[0].amountOfUsers = res[0].item;
      }
      if (res[1]) {
        this.listOfCampagnes[1].amountOfUsers = res[1].item;
      }
      if (res[2]) {
        this.listOfCampagnes[2].amountOfUsers = res[2].item;
      }
      if (res[3]) {
        this.listOfCampagnes[3].amountOfUsers = res[3].item;
      }
      if (res[4]) {
        this.listOfCampagnes[4].amountOfUsers = res[4].item;
      }
      if (res[5]) {
        this.listOfCampagnes[5].amountOfUsers = res[5].item;
      }
    });
  },
  methods: {
    setSnackbar(event) {
      this.snackbar = true;
      this.text = event.text;
      this.color = event.color;
    },
  },
};
</script>
    
    <style>
</style>